import { ExtendedPart, isJobProcessing } from "shared";

export const getIsAnalyzingPart = (part: ExtendedPart): boolean => {
  return (
    isJobProcessing(part.previewStatus) ||
    isJobProcessing(part.gltfStatus) ||
    isJobProcessing(part.featuresStatus) ||
    isJobProcessing(part.graphStatus)
  );
};
